export default "__VITE_ASSET__l$9NPoDg__"